import React from 'react';

const Dot = () => {
  return <div className="w-1 h-1 rounded-full bg-gray-800" />;
};

export default Dot;
